import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";

import ApplicationStatusMessageDeactivateContainer from "./ApplicationStatusMessageDeactivateContainer";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Application",
    render: (row) => row.application.application_name,
  },
  {
    name: "Activated at",
    render: (row) => row.activated_at,
  },
  {
    name: "Activated by",
    render: (row) => row.admin_user_activate,
  },
  {
    name: "Deactivated at",
    render: (row) => row.deactivated_at,
  },
  {
    name: "Deactivated by",
    render: (row) => row.admin_user_deactivate,
  },
  {
    name: "Category",
    render: (row) => row.status_message.category,
  },
  {
    name: "Level",
    render: (row) => row.status_message.level,
  },
  {
    name: "Message body",
    render: (row) => row.status_message.message_body,
  },
  {
    name: "Deactivate",
    render: (row) => (
      <ApplicationStatusMessageDeactivateContainer
        applicationStatusMessage={row}
      />
    ),
  },
];

export default columnConfigs;
